export const FIELDS_CONFIG = [
  {
    id: 'facilitating_location',
    label: 'Facilitating Location',
    valueType: 'link',
    valueLinkText:
      'automatically fetched from the Facilitating Location file, to edit go',
    valueLinkUrl: '/facilitating-locations',
  },
  {
    id: 'lanes',
    label: 'Lane(s)',
    valueType: 'link',
    valueLinkText: 'automatically fetched from the Lane(s) file, to edit go',
    valueLinkUrl: '/lanes',
  },
  {
    id: 'sales_channel',
    label: 'Sales Channel',
    valueType: 'multiselect',
    valueOptions: [
      { key: 'live_auction', text: 'Live Auction', value: 'live_auction' },
      { key: 'online', text: 'Online', value: 'online' },
    ],
    selectedValues: ['live_auction', 'online'],
  },
  {
    id: 'pickup_location',
    label: 'Pickup Location',
    valueType: 'multiselect',
    valueOptions: [],
    selectedValues: [],
  },
  {
    id: 'sale_type',
    label: 'Sale Type',
    valueType: 'multiselect',
    valueOptions: [
      { key: 'absolute', text: 'Absolute', value: 'absolute' },
      { key: 'if_bid', text: 'If Bid', value: 'if_bid' },
    ],
    selectedValues: ['absolute', 'if_bid'],
  },
  {
    id: 'vehicle_location',
    label: 'Vehicle Location',
    valueType: 'multiselect',
    valueOptions: [],
    selectedValues: [],
  },
  {
    id: 'vehicle_health_score',
    label: 'Vehicle Health Score',
    valueType: 'buckets',
    buckets: [
      { label: 'Bucket 1, minimal accepted value:', value: 70 },
      { label: 'Bucket 2, minimal accepted value:', value: 70 },
      { label: 'Bucket 3, minimal accepted value:', value: 70 },
      { label: 'Bucket 4, minimal accepted value:', value: 70 },
      { label: 'Bucket 5, minimal accepted value:', value: 70 },
    ],
  },
  {
    id: 'business_unit',
    label: 'Business Unit',
    valueType: 'include_multiselect',
    includeExclude: 'include',
    valueOptions: [],
    selectedValues: [],
  },
  {
    id: 'make_model',
    label: 'Make/Model',
    valueType: 'link',
    valueLinkText:
      'automatically fetched from the Make/Model to Exclude file, to edit go',
    valueLinkUrl: '/make-model',
  },
  {
    id: 'fuelTypeEligibilityRule',
    label: 'Fuel Type',
    valueType: 'multiselect',
  },
  {
    id: 'inventory_source_buyer_group',
    label: 'Inventory Source/Buyer Group',
    valueType: 'multiselect',
    valueOptions: [],
    selectedValues: [],
  },
  {
    id: 'cr_grade',
    label: 'CR Grade, minimal accepted value',
    valueType: 'number_input',
    numberValue: 1,
  },
  {
    id: 'cr_type',
    label: 'CR Type',
    valueType: 'static_text',
    staticText: 'include only Manheim-classified CRs',
  },
  {
    id: 'crossover',
    label: 'Crossover',
    valueType: 'static_text',
    staticText: 'do not allow crossover',
  },
  {
    id: 'mmrEligibilityRule',
    label: 'MMR Eligibility',
    valueType: 'range',
    rangeMin: 0,
    rangeMax: 200000,
  },
  {
    id: 'saPurchasePriceEligibilityRule',
    label: 'SA Purchase Price Eligibility',
    valueType: 'range',
    rangeMin: 0,
    rangeMax: 200000,
  },
  {
    id: 'pricing_percent_mmr',
    label: 'Pricing – % of MMR – post-sale',
    valueType: 'range',
    rangeMin: 80,
    rangeMax: 120,
  },
  {
    id: 'saPricingPercentOfMmrRule',
    label: 'SA Pricing % of MMR',
    valueType: 'range',
    rangeMin: 40,
    rangeMax: 110,
  },
  {
    id: 'saPricingDollarOverMmrRule',
    label: 'SA Pricing $ over MMR',
    valueType: 'number_input',
    numberValue: 3500,
  },
  {
    id: 'ageEligibilityRule',
    label: 'SA Age Eligibility',
    valueType: 'number_input',
    numberValue: 20,
  },
  {
    id: 'conditionReportEligibilityRule',
    label: 'Condition Report Grade Eligibility',
    valueType: 'number_input',
    numberValue: 1,
  },
  {
    id: 'crTypeEligibilityRule',
    label: 'SA Condition Report Type Eligibility',
    valueType: 'static_text',
    staticText: 'include only Manheim-classified CRs',
  },
  {
    id: 'saLightEligibilityRule',
    label: 'SA Light Color Eligibility',
    valueType: 'multiselect',
    options: ['GREEN', 'YELLOW', 'RED'],
  },
  {
    id: 'saAnnouncementEligibilityRule',
    label: 'SA Announcement Eligibility',
    valueType: 'static_text',
    staticText: 'do not allow ineligibility keywords in announcements',
  },
  {
    id: 'saPreviousTRAEligibilityRule',
    label: 'Previous TRA',
    valueType: 'static_text',
    staticText: 'deny vehicle if previous TRA problem file is found',
  },
  {
    id: 'oveManExEligibilityRule',
    label: 'OVE/ManEx Eligibility',
    valueType: 'static_text',
    staticText: 'do not allow OVE/ManEx ineligibility keywords',
  },
  {
    id: 'title',
    label: 'Title',
    valueType: 'include_exclude_multiselect',
    includeExclude: 'exclude',
    valueOptions: [{ key: 'salvage', text: 'Salvage', value: 'salvage' }],
    selectedValues: ['salvage'],
  },
  {
    id: 'model_year',
    label: 'Model Year',
    valueType: 'condition_builder',
    conditions: [
      {
        includeExclude: 'include',
        comparison: 'gte',
        field: 'Model Year',
        value: 2015,
      },
    ],
    allowAddCondition: true,
  },
  {
    id: 'odometer_less_than',
    label: 'Odometer, less then',
    valueType: 'number_input',
    numberValue: 0,
  },
  {
    id: 'autocheck_activity_codes',
    label: 'Autocheck Activity Codes',
    valueType: 'search_input',
    searchPlaceholder: 'Start typing to search',
    searchValue: '',
    allowAddCondition: true,
  },
  {
    id: 'autocheck_odometer_rollback',
    label: 'Autocheck Odometer rollback flag',
    valueType: 'static_text',
    staticText: 'do not allow odometer rollback flag',
  },
  {
    id: 'announcement_keywords',
    label: 'Announcement Keywords/F5 Notes',
    valueType: 'search_input',
    searchPlaceholder: 'Start typing to search',
    searchValue: '',
    allowAddCondition: true,
  },
  {
    id: 'disclosure_keywords',
    label: 'Disclosure Keywords',
    valueType: 'search_input',
    searchPlaceholder: 'Start typing to search',
    searchValue: '',
    allowAddCondition: true,
  },
  {
    id: 'vin_blacklist',
    label: 'VIN Blacklist',
    valueType: 'link',
    valueLinkText: 'automatically fetched from the VIN Blacklist, to edit go',
    valueLinkUrl: '/vin-blacklist',
  },
  {
    id: 'lights',
    label: 'Lights',
    valueType: 'multiselect',
    valueOptions: [],
    selectedValues: [],
  },
  {
    id: 'traStatusEligibilityRule',
    label: 'TRA Status',
    valueType: 'static_text',
    staticText: 'do not allow TRA',
  },
  {
    id: 'as_is_status',
    label: 'As-Is Status',
    valueType: 'static_text',
    staticText: 'do not allow As-Is',
  },
  {
    id: 'lemon_law',
    label: 'Lemon Law',
    valueType: 'static_text',
    staticText: 'do not allow Lemon Law',
  },
  {
    id: 'vehicle_problem_file',
    label: 'Vehicle Problem File',
    valueType: 'search_input',
    searchPlaceholder: 'Start typing to search',
    searchValue: '',
    allowAddCondition: true,
  },
  {
    id: 'times',
    label: 'Times (see 3.1 PSI policy)',
    valueType: 'time_picker',
    timeCondition: 'after',
    timeHour: 5,
    timeMinute: 0,
    timePeriod: 'PM',
    timeZone: 'EST',
    allowAddCondition: true,
  },
  {
    id: 'certification_status',
    label: 'Certification status',
    valueType: 'empty',
  },
  {
    id: 'salesChannelEligibilityRule',
    label: 'SA Sales Channel',
    valueType: 'multiselect',
  },
  {
    id: 'ineligibleLaneEligibilityRule',
    label: 'Ineligible Lane Eligibility',
    valueType: 'link',
    valueLinkText: 'automatically fetched from the Ineligible Lanes file, to edit go',
  },
  {
    id: 'vinBlacklistEligibilityRule',
    label: 'SA VIN Blacklist Eligibility',
    valueType: 'link',
    valueLinkText: 'automatically fetched from the VIN Blacklist, to edit go',
    valueLinkUrl: '/vin_blacklists/',
  },
  {
    id: 'businessUnitEligibilityRule',
    label: 'SA Business Unit Eligibility',
    valueType: 'static_text',
    staticText: 'deny vehicle if prime code is T (TRA), H (heavy duties), or S (specialty car)',
  },
];

// Maximum number of conditions that can be added per field
// Set to Infinity for unlimited conditions, or a number (e.g., 5) to limit
export const MAX_CONDITIONS_PER_FIELD = 5;

// Valid canonical values for the actionOnNull rule field
export const VALID_ACTION_ON_NULL_VALUES = ['IGNORE', 'DENY'];

// Default used when a stored/legacy actionOnNull value is missing or unrecognized
export const DEFAULT_ACTION_ON_NULL = VALID_ACTION_ON_NULL_VALUES[0];
